module.exports = __webpack_public_path__ + "img/index-rcfw2.7ed8f2b2.png";